import { Typography, Box } from '@coolblue-development/freddy';
import EmailTransferIcon from '../../../Icons/EmailTransferIcon';

interface TransferConfirmationProps {
  queueName: string;
}

const TransferConfirmation = ({ queueName }: TransferConfirmationProps): JSX.Element => (
  <Box sx={{ margin: '8px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <EmailTransferIcon />
      <Typography variant="h6" color="subtle" sx={{ fontWeight: 400 }}>
        Transferred to <strong>{queueName}</strong>
      </Typography>
    </Box>
  </Box>
);

export default TransferConfirmation;
